export enum PermissionIdentifier {
  SystemManagement = 'ObasService.SystemManagement',
  UserManagement = 'ObasService.Users',
  PermissionManagement = 'ObasService.PermissionManagement',
  MenuManagement = 'ObasService.MenuManagement',
  DictionaryManagement = 'ObasService.DataDictionary',
  LogManagement = 'ObasService.LogManagement',
  AITest = 'ObasService.AITest',
  SystemDataManagement = 'ObasService.SystemDataManagement',
  MaterialType = 'ObasService.MaterialType',
  VCAttribute = 'ObasService.VCAttribute',
  ModuleList = 'ObasService.ModuleList',
  Reminder = 'ObasService.Reminder',
  Proofreading = 'ObasService.Proofreading',
  ApprovalProcess = 'ObasService.ApprovalProcess',
  WorkflowApproval = 'ObasService.WorkflowApproval',
  MyApplication = 'ObasService.MyApplication',
  PendingApproval = 'ObasService.PendingApproval',
  OrderQuery = 'ObasService.OrderQuery',
  SimulatedBOM = 'ObasService.SimulatedBOM',
  MaterialMasterDataQuery = 'ObasService.MaterialMasterQuery',
  ProductCodeQuery = 'ObasService.ProductCodeQuery',
  VcLevel1Query = 'ObasService.VcLevel1Query',
  HomePageManagement = 'ObasService.HomePageManagement',
}

function access(initialState: InitialState) {
  // 在这里按照初始化数据定义项目中的权限，统一管理
  // 参考文档 https://umijs.org/docs/max/access
  // const mock = Object.values(PermissionIdentifier)
  // const userPerms: PermissionIdentifier[] = mock|| [];
  const userPerms: string[] = (initialState.permissions || []).map(
    (item) => item.name as string,
  );

  const has = (perm: string) => {
    if (!userPerms || userPerms.length === 0) return false;
    return userPerms.includes(perm);
  };

  const getPermission = (perms: string[]) => {
    const permissionsMap: Record<string, boolean> = {};
    if (!perms || perms.length === 0) return permissionsMap;
    perms.forEach((perm) => {
      permissionsMap[perm] = has(perm);
    });
    return permissionsMap;
  };

  const allKnownPerms = [
    ...Object.values(PermissionIdentifier),
    ...userPerms.filter(
      (p) => !Object.values(PermissionIdentifier).includes(p as PermissionIdentifier),
    ),
  ];

  return {
    ...getPermission(allKnownPerms),
    // 公开函数：按需检查任意权限
    hasPermission: has,
  };
}

export default access;
